React = require 'react'
CreateBoardView = require 'views/board/create-board-view'
CreateBoardComponent = require 'views/board-create/create-board-component'
CreateOrgView = require 'views/organization/create-org-view'
Dialog = require 'views/lib/dialog'
PopOver = require 'views/lib/pop-over'
getExperiment = require 'lib/experiments/simple-test'
Util = require 'lib/util'
View = require 'view'
templates = require 'views/internal/templates'
track = require 'debug/track'
ClientConfig = require 'debug/client-config'
headerAddMenu = require 'views/templates/header_add_menu'

module.exports = class HeaderAddMenuView extends View
  viewTitleKey: 'create'

  events:
    'click .js-new-board': 'newBoard'
    'click .js-new-org': 'newOrg'
    'click .js-new-bc-org': 'newBCOrg'

  render: ->

    @$el.html(
      headerAddMenu({
        upsellEnabled: !ClientConfig.get('dontUpsell')
      })
    )

    @

  newBoard: (e) ->
    track("Header", "Add Menu", "New Board")

    Util.stop(e)

    withBackground = getExperiment('createBoardWithBackground')?.get('enabled')

    if withBackground
      Dialog.show
        displayType: 'mod-no-chrome'
        opacity: 0.75
        reactElement: React.createElement CreateBoardComponent
    else
      PopOver.pushView
        view: new CreateBoardView({ @model, @modelCache, useLastOrganization: true })

  newOrg: (e) ->
    track("Header", "Add Menu", "New Org")

    Util.stop(e)

    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache })

  newBCOrg: (e) ->
    track("Header", "Add Menu", "New Business Class Org")
    createOpts = { isBusinessClass: true }

    Util.stop(e)

    PopOver.pushView
      view: new CreateOrgView({ @model, @modelCache, createOpts })



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-add-menu-view.coffee